var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrival(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 50,
    viewBox: "0 0 320 297",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M316.5 148.5C316.5 228.34 246.683 293.5 160 293.5C73.317 293.5 3.5 228.34 3.5 148.5C3.5 68.66 73.317 3.5 160 3.5C246.683 3.5 316.5 68.66 316.5 148.5Z",
    stroke: "black",
    strokeWidth: 15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M242.104 232L231.226 197.553H170.879L160.001 232H129.18L187.973 55.88H215.427L274.479 232H242.104ZM187.714 143.681L179.685 169.063H222.161L214.132 143.681L201.182 99.133L187.714 143.681Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.01 155.01C148.33 151.691 148.33 146.309 145.01 142.99L90.9167 88.8959C87.5973 85.5765 82.2154 85.5765 78.8959 88.8959C75.5765 92.2154 75.5765 97.5973 78.8959 100.917L126.979 149L78.8959 197.083C75.5765 200.403 75.5765 205.785 78.8959 209.104C82.2154 212.424 87.5973 212.424 90.9167 209.104L145.01 155.01ZM19 157.5H139V140.5H19V157.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrival);
export default __webpack_public_path__ + "static/media/arrival.b20c0ac4698c49d3fe7a895baa5098c4.svg";
export { ForwardRef as ReactComponent };